import * as React from "react";
import { styled } from "@mui/material/styles";
import Button from "@mui/material/Button";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import * as XLSX from "xlsx";

const VisuallyHiddenInput = styled("input")({
  clip: "rect(0 0 0 0)",
  clipPath: "inset(50%)",
  height: 1,
  overflow: "hidden",
  position: "absolute",
  bottom: 0,
  left: 0,
  whiteSpace: "nowrap",
  width: 1,
});

export default function InputFileUpload({ setFile }) {
  const [fileContents, setFileContents] = React.useState(XLSX.utils.book_new());
  const [preview, setPreview] = React.useState(false);
  const [fileName, setFileName] = React.useState("");

  const handleFileChange = async (event) => {
    setPreview(false);
    const file = event.target.files[0];
    if (
      file.type ===
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" ||
      file.type === "application/vnd.ms-excel"
    ) {
      console.log(file);
      setFile(file);
      setFileName(file.name);
      const f = await file.arrayBuffer();
      const wb = XLSX.read(f);
      setFileContents(wb);
      setPreview(true);
    } else {
      alert("Please select an Excel file.");
    }
  };

  return (
    <>
      <Button
        component="label"
        role={undefined}
        variant="contained"
        tabIndex={-1}
        startIcon={<CloudUploadIcon />}
      >
        Загрузить файл
        <VisuallyHiddenInput
          type="file"
          onChange={handleFileChange}
          accept=".xlsx, .xls"
        />
      </Button>
      {preview && <h3>{fileName}</h3>}
      {/* {preview && (
        <div
          style={{
            backgroundColor: "white",
            color: "black",
          }}
        >
          <div
            dangerouslySetInnerHTML={{
              __html: XLSX.utils.sheet_to_html(
                fileContents.Sheets[fileContents.SheetNames[0]]
              ),
            }}
          />
        </div>
      )} */}
    </>
  );
}
